/**
 * スタッフ詳細ダイアログ専用i18n定数
 */

export const STAFF_DETAILS_I18N = {
  // 性別オプション
  sex: {
    male: $localize`:@@admin.staffDetails.sex.male:男性`,
    female: $localize`:@@admin.staffDetails.sex.female:女性`,
    other: $localize`:@@admin.staffDetails.sex.other:その他`,
  },

  // ステータス
  status: {
    active: $localize`:@@admin.staffDetails.status.active:有効`,
    inactive: $localize`:@@admin.staffDetails.status.inactive:無効`,
  },

  // デフォルト値
  defaultUserType: $localize`:@@admin.staffDetails.defaultUserType:スタッフ`,

  // ボタン
  button: {
    close: $localize`:@@admin.staffDetails.button.close:閉じる`,
  },

  // メッセージ
  message: {
    updateSuccess: (userType: string) =>
      $localize`:@@admin.staffDetails.message.updateSuccess:${userType}:userType:の情報を更新しました。`,
    updateError: (userType: string) =>
      $localize`:@@admin.staffDetails.message.updateError:${userType}:userType:の情報の更新に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
    inviteSuccess: (userType: string) =>
      $localize`:@@admin.staffDetails.message.inviteSuccess:${userType}:userType:を招待しました。`,
    inviteError: (userType: string) =>
      $localize`:@@admin.staffDetails.message.inviteError:${userType}:userType:の招待に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
  },
} as const;

export type StaffDetailsI18n = typeof STAFF_DETAILS_I18N;
